interface IProps {
  className?: string;
  white?: boolean;
}

const Circle = ({ className, white }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
      viewBox="0 0 24 24"
      fill="none"
    >
      <circle
        opacity={white ? "1" : "0.2"}
        cx="11.9996"
        cy="11.9996"
        r="9.4"
        stroke={white ? "#ffffff" : "currentColor"}
        strokeWidth="2"
      />
      <path
        d="M21.5996 12.8004C21.9996 6.80039 17.1996 2.40039 11.5996 2.40039"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  );
};

export default Circle;
